import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';

import { IAppRootState } from '../../core/store';
import { chartOriginalReducer } from './chart.reducer';
import { ChartOriginalSliceState, ChartSliceKey } from './chart.state';

export const ChartFeatureKey = 'Chart';

export interface ChartFeatureState {
	[ChartSliceKey]: ChartOriginalSliceState;
}

export interface ChartRootState extends IAppRootState {
	[ChartFeatureKey]: ChartFeatureState;
}

export const featureSelector =
	createFeatureSelector<ChartFeatureState>(ChartFeatureKey);

export const chartReducers: ActionReducerMap<ChartFeatureState> = {
	[ChartSliceKey]: chartOriginalReducer,
};
